import css from 'styled-jsx/css';

export default css`
  .Post {
    background-color: inherit;
  }
`;
